import { BankAccountApi } from "@/api/BankAccountApi";
import { CreditOperatorApi } from "@/api/CreditOperatorApi";
import { EDITOR_INPUT, RADIO_INPUT_TYPE, SELECT_INPUT_TYPE, Yup } from "@mavichpe/dynamic-forms";
import { CARD_PAYMENT_WAY_CODE, CHEQUE_PAYMENT_WAY_CODE, DIGITAL_PLATFORM_PAYMENT_WAY_CODE, SINPE_PAYMENT_WAY_CODE, TRANSFER_PAYMENT_WAY_CODE } from "@utils/Constants";
import { generatePaymentWayOptions } from "@utils/EDocument";

const DocumentPaymentWaysConfig = {
    submit: {
        label: "Agregar"
    },
    sections: [
        {
            hideBorderBottom: true,
            "fields": [
                [
                    {
                        "type": RADIO_INPUT_TYPE,
                        "name": "forma_pago",
                        "label": "Forma de Pago",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 10
                        },
                        "options": generatePaymentWayOptions(),
                        "validation": Yup.string().required("Este campo es requerido"),
                    }
                ],
                [
                    {
                        "type": "money",
                        "name": "monto",
                        "label": "Monto",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 3
                        },
                        "validation": Yup.number().required("Este campo es requerido").min(0, "El Monto tiene que ser mayor a 0"),
                    }
                ],
                [
                    {
                        "type": "number",
                        "name": "digitosTarjeta",
                        "label": "Ultimos 4 digitos",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 3
                        },
                        "visibleIf": {
                            "forma_pago": `${CARD_PAYMENT_WAY_CODE}`
                        }
                    }
                ],
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "creditOperatorId",
                        "label": "Operador de Tarjeta",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 6
                        },
                        "optionsFunction": () => CreditOperatorApi.optionsList(),
                        "visibleIf": {
                            "forma_pago": `${CARD_PAYMENT_WAY_CODE}`
                        }
                    }
                ],
                [
                    {
                        "type": "number",
                        "name": "numAprobacion",
                        "label": "Numero Aprobacion",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 3
                        },
                        "visibleIf": {
                            "forma_pago": `${CARD_PAYMENT_WAY_CODE}`
                        }
                    }
                ],
                [
                    {
                        "type": "number",
                        "name": "reference",
                        "label": "Numero Referencia",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 3
                        },
                        "visibleIf": {
                            "forma_pago": [
                                `${CHEQUE_PAYMENT_WAY_CODE}`,
                                `${TRANSFER_PAYMENT_WAY_CODE}`,
                                `${SINPE_PAYMENT_WAY_CODE}`,
                                `${DIGITAL_PLATFORM_PAYMENT_WAY_CODE}`,
                            ]
                        }
                    }
                ],
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "bankAccountId",
                        "label": "Cuenta Bancaria",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 6
                        },
                        "visibleIf": {
                            "forma_pago": [
                                `${CHEQUE_PAYMENT_WAY_CODE}`,
                                `${TRANSFER_PAYMENT_WAY_CODE}`,
                                `${SINPE_PAYMENT_WAY_CODE}`,
                                `${DIGITAL_PLATFORM_PAYMENT_WAY_CODE}`,
                            ]
                        },
                        "optionsFunction": () => BankAccountApi.optionsList(),
                    }
                ],
            ]
        }
    ],
};


export default DocumentPaymentWaysConfig;